import { PageTitle } from "@/components/custom/PageTitle";
import { CategoryProgressCard } from "@/components/custom/TCS200/CategoryProgressCard";
import { WorkflowsProgress } from "@/components/custom/TCS200/WorkflowsProgress";
import { RootState } from "@/redux";
import { useSelector } from "react-redux";

export const TCS200 = () => {
  const { organizations } = useSelector((state: RootState) => state.organization)

  const totalWorkflows = organizations?.reduce(
    (sum, org) => sum + Number(org.allWorkflowCount || 0),
    0
  );
  const activeWorkflows = organizations?.reduce(
    (sum, org) => sum + Number(org.activeWorkflowCount || 0),
    0
  );
  const totalWorkflowExecutions = organizations?.reduce(
    (sum, org) => sum + Number(org.allWorkflowExecutionCount || 0),
    0
  );
  const activeWorkflowExecutionCount = organizations?.reduce(
    (sum, org) => sum + Number(org.activeWorkflowExecutionCount || 0),
    0
  );
  const activeUsers = organizations?.reduce(
    (sum, org) => sum + Number(org.activeUserCount || 0),
    0
  );

  return (
    <div className="protectedPageLayout">
      <PageTitle title="TCS 200" />
      <div className="flex flex-row">
        <WorkflowsProgress workflowsCount={activeWorkflows || 0} />
        <div className="w-5" />
        <CategoryProgressCard
          categoryType="Total Workflows"
          categoryTypeProgressCount={totalWorkflows || 0}
        />
      </div>
      <div className="flex flex-row mt-5">
        <CategoryProgressCard
          categoryType="Organizations"
          categoryTypeProgressCount={organizations?.length || 0}
        />
        <CategoryProgressCard
          categoryType="Users"
          categoryTypeProgressCount={activeUsers || 0}
        />
        <CategoryProgressCard
          categoryType="Active Executions"
          categoryTypeProgressCount={activeWorkflowExecutionCount || 0}
        />
        <CategoryProgressCard
          categoryType="Total Executions"
          categoryTypeProgressCount={totalWorkflowExecutions || 0}
        />
      </div>
    </div>
  )
};
